angular.module('bribac.validators.equals', [])

  .directive('equals', function() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function(scope, element, attr, ngModelCtrl) {
        if (!ngModelCtrl) return

        var expectedValue = attr.equals

        ngModelCtrl.$validators.equals = function(modelValue, viewValue) {
          return viewValue === expectedValue
        };

        attr.$observe('equals', function(interpolatedValue) {
          expectedValue = interpolatedValue
          ngModelCtrl.$validate();
        });
      }
    }
  })
